import React from 'react'
import SideNav from '../../layouts/side-nav.js'
import {experience, achievements} from './data/experience.json'

import './style/index.css'

const components = ['experience', 'memberships', 'testimonials']

export default (props) => (
  <div>
    <div className='experience-hero'>
      <div className='experience-hero-img' />
    </div>
    <div className='experience-title'>
      Steven B. Geller, CLFP
    </div>
    <div className='experience-content'>
      <SideNav components={components} base='experience' current='experience' />
      <div className='experience'>
        <div className='experience-subtitle'>
          Professional Experience
        </div>
        <ul className='experience-bullets'>
          {experience.map((expObj, i) => (
            <li key={i} className='experience-bullet'>
              {expObj.company}
              {expObj.description && (
                <ul className='nested-experience-bullets'>
                  <li className='nested-experience-bullet'>
                    {expObj.description}
                  </li>
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className='achievements'>
        <div className='achievements-title'>
          Professional Achievements and Industry Designations
        </div>
        <ul className='achievements-bullets'>
          {achievements.map((achObj, i) => (
            <li key={i} className='achievements-bullet'>
              {achObj.company}
              <ul className='nested-achievements-bullets'>
                <li className='nested-achievements-bullet'>
                  {achObj.responsibilities}
                </li>
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/experience/index.js